export default {
  labels: {
    invoice: 'Auf Rechnung',
    on_site: 'Vor Ort zahlen (Bar/Karte)',
  },
};
